import { Component, Input, OnChanges } from '@angular/core';
import { ScorecardChart, ScorecardChartVm } from '../../../../domain/model/partner-scorecard.model';

/** Declined bars are drawn 24 px at a 32 px pitch, so the canvas grows with the reasons it lists. */
const DECLINED_ROW_REM = 2;

/** One scorecard card: title, subtitle, the bars or the empty copy, then VIEW REPORT and the as-of footer. */
@Component({
  selector: 'ifbp-scorecard-bar-chart',
  templateUrl: './scorecard-bar-chart.component.html',
  styleUrls: ['./scorecard-bar-chart.component.scss'],
  standalone: false,
})
export class ScorecardBarChartComponent implements OnChanges {
  @Input() vm: ScorecardChartVm;
  /** The declined card's `+N more`; null on every other card. */
  @Input() moreLabel: string | null = null;

  /** Inline height of the declined canvas; null leaves the month cards' fixed height. */
  canvasHeight: string | null = null;

  ngOnChanges(): void {
    const rows = this.vm?.chart === ScorecardChart.DECLINED_REASONS ? (this.vm.data?.labels?.length ?? 0) : 0;
    this.canvasHeight = rows > 0 ? `${rows * DECLINED_ROW_REM}rem` : null;
  }
}
